import { useEffect } from 'react'
import { useAuthContext } from '../../auth/context/auth/AuthProvider'
import useAuthActions from '../../auth/hooks/useAuthActions'
import { Outlet, useNavigate } from 'react-router-dom'
import LoaderSplash from '../components/LoaderSplash'

export default function SplashPage() {
  const { authState } = useAuthContext()
  const { getCurrentUser } = useAuthActions()
  const navigate = useNavigate()

  useEffect(() => {
    getCurrentUser()
  }, [])

  useEffect(() => {
    if (!authState.isLoading && authState.currentUser === null) {
      navigate('/session/login')
    }
  }, [authState.isLoading, authState.currentUser])

  if (authState.isLoading && authState.currentUser === null) {
    return <LoaderSplash />
  }

  return <Outlet />
}
